import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { message, Card } from "antd"; // Added Card here
import moment from "moment";
import ReactLoading from "react-loading";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import isConsultant from "../services/isConsultant";
import useAxios from "../hooks/useAxios";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;

const FeedbackReport = () => {
  const api = useAxios()
  const [defaultDate, setDefaultDate] = useState([]);
  const [load, setLoad] = useState(false);
  const [startDate, setStartDate] = useState();

  const [canViewFeedbackReport, setCanViewFeedbackReport] = useState(false);
  const [canDownloadFeedbackReport, setCanDownloadFeedbackReport] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "feedback_report_module",
        "view_feedback_report"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "feedback_report_module",
        "download"
      );
      setCanViewFeedbackReport(viewAllowed);
      setCanDownloadFeedbackReport(downloadAllowed);
    } catch (err) {
      console.error("Error checking feedback report permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  function disableFutureDates(current) {
    const maxDate = startDate
      ? moment(startDate).add(3, "month")
      : moment().endOf("day");
    return current && (current > moment().endOf("day") || current > maxDate);
  }

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  const loadCSV = async () => {
    try{
      const result = await api.get(`/candidateFeedBack?StartDate=${
        defaultDate[0]
          ? defaultDate[0]
          : moment(new Date()).format("YYYY-MM-DD")
      }&EndDate=${
        defaultDate[1]
          ? defaultDate[1]
          : moment(new Date()).format("YYYY-MM-DD")
      }`,{tokenType : 'user'})
      return result.data
    }catch(err) {
      throw err
    }
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  //CSV DATA
  const downloadCSV = async () => {
    try{
      setLoad(true)
      const csvData = await loadCSV()
      if(csvData?.feedBackList?.length === 0){
        return message.error("No data found.",2)
      }
  
      const mergeKeyValue = {
        ...csvData,
        feedBackList: csvData?.feedBackList?.map((feedback) => {
          const newFeedback = {};
          feedback.feedBack.forEach((question) => {
            newFeedback[question.label] = question.value;
          });
          return {
            ...feedback,
            feedBack: newFeedback,
          };
        }),
      };
  
      const updatedData = {
        ...mergeKeyValue,
        feedBackList: mergeKeyValue?.feedBackList?.map((feedback) => {
          const entries = Object.entries(feedback.feedBack);
          return {
            ...feedback,
            ...Object.fromEntries(entries),
          };
        }),
      };
  
      let finalData = {
        ...updatedData,
        feedBackList: updatedData?.feedBackList?.map((feedback) => {
          delete feedback.feedBack;
          return feedback;
        }),
      };
  
      let removeDelimiter = finalData?.feedBackList?.map((obj) => {
        let newObj = {};
        for (let key in obj) {
          newObj[key.replaceAll(",", "")] = obj[key];
        }
        return newObj;
      });
  
      const spreadCandidateId = removeDelimiter.map(
        ({ candidateId, ...rest }) => ({
          ...candidateId,
          ...rest,
        })
      );
      let fileName = `Feedback_Report_${moment(new Date()).format(
        "DD-MM-YYYY_HH:mm"
      )}`;
      const exportType = "csv";
      let data = spreadCandidateId;
      exportFromJSON({ data, fileName, exportType });

    }catch(err) {
      console.log(err)
      message.warning("An Error Occurred.", 2);
    }finally{
      setLoad(false)
    }

  };

  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Feedback Report">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          {canViewFeedbackReport ? (
            <div className="row p-3 border mb-2 bg-white cursor-pointer">
              <div className="col-md-4">
                <label htmlFor="candidate photo">
                  Select Date
                  <span style={{ color: "red" }}>*</span>
                </label>
                <RangePicker
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                  onChange={handleDate}
                  onOk={onOk}
                  defaultValue={[moment(), moment()]}
                  onCalendarChange={handleCalendarChange}
                  disabledDate={disableFutureDates}
                  placeholder={[
                    moment(new Date()).format("YYYY-MM-DD"),
                    moment(new Date()).format("YYYY-MM-DD"),
                  ]}
                />
              </div>
              {canDownloadFeedbackReport && (
                <div className="col-md-3 align-items-end d-flex">
                  <button
                    className="btn btn-primary btn-block"
                    onClick={downloadCSV}
                  >
                    Download CSV
                  </button>
                </div>
              )}
            </div>
          ) : (
            !load && <Card className="p-3">You are not authorized to view this report.</Card>
          )}

          {/* <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
        <table className="table bg-white ">
          <thead>
            <tr>
              <th>Name</th>
              <th>OTP</th>
              <th>OTP Status</th>
              <th>Name</th>
              <th>OTP</th>
              <th>OTP Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Name</td>
              <td>OTP</td>
              <td>OTP Status</td>
              <td>Name</td>
              <td>OTP</td>
              <td>OTP Status</td>
            </tr>
          </tbody>
        </table>
        <Pagination current={current} onChange={onChange} total={50} />
      </div> */}
        </Dashboard>
      )}
    </div>
  );
};

export default FeedbackReport;
